import React from "react";
import { Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import CpdIllustration from "../../../../assets/images/CDP_Illustration.png";

const CHECKLIST = [
  "Connect customer data from every source",
  "Unify records into complete profiles",
  "Enrich profiles with behavioural context",
  "Activate customer data across destinations",
];

// "Setup your first connection" hero card at the top of the Connections
// Overview screen — matches the provided screenshot's two-column layout.
export const OverviewHero: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 p-6 sm:p-8 shadow-sm overflow-hidden">
      <div className="flex flex-col lg:flex-row items-center gap-8">
        <div className="flex-1 min-w-0">
          <h2 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-gray-100">
            Setup your first connection
          </h2>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-2 max-w-md leading-relaxed">
            Connect your customer data sources and destinations to start building unified profiles and activating
            them across your tools.
          </p>
          <button
            type="button"
            onClick={() => navigate("/track/connections/new")}
            className="mt-5 px-5 py-2.5 text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 rounded-lg transition-colors shadow-sm"
          >
            Setup Your First Connection
          </button>
        </div>

        <div className="hidden sm:block w-px self-stretch bg-gray-100 dark:bg-gray-800" />

        <div className="flex-1 min-w-0 flex items-center gap-6">
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-bold text-gray-900 dark:text-gray-100">From fragmented to actionable</h3>
            <ul className="mt-3 space-y-2.5">
              {CHECKLIST.map((item) => (
                <li key={item} className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-300">
                  <span className="inline-flex items-center justify-center w-4 h-4 rounded-full border border-gray-300 dark:border-gray-600 shrink-0">
                    <Check size={10} className="text-gray-500 dark:text-gray-400" />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <img
            src={CpdIllustration}
            alt=""
            className="hidden md:block w-32 lg:w-40 shrink-0 object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default OverviewHero;
